'use client';
import type React from 'react';
import { Heading } from '@//components/Heading';
import { Skeleton } from '@//components/Skeleton';
import { ExtendTextContentContainer } from '@//containers/ExtendTextContentContainer';
import useSearchSubscription from '@//data/subscriptions/search/useSearchSubscription';
import styles from './SearchHeader.module.scss';

interface SearchHeaderProps {
  heading: React.ReactNode | string;
  label?: string;
  description?: React.ReactNode;
  searchSubscriptionId?: string;
}

export const SearchHeader: React.FC<SearchHeaderProps> = ({
  heading,
  label,
  description,
  searchSubscriptionId,
}) => {
  const searchSubscriptionQuery = useSearchSubscription(searchSubscriptionId);

  return (
    <header className={styles.header}>
      <div className={styles.heading}>
        {label && <div className={styles.label}>{label}</div>}
        <Heading level={1} size="3xl" font="brand" aria-busy={searchSubscriptionQuery.isFetching}>
          {searchSubscriptionId ? (
            (searchSubscriptionId &&
              !searchSubscriptionQuery.isError &&
              !searchSubscriptionQuery.isSuccess) ||
            searchSubscriptionQuery.isFetching ? (
              <Skeleton width="400px" height="1lh" />
            ) : (
              searchSubscriptionQuery.data?.response?.name
            )
          ) : (
            heading
          )}
        </Heading>
      </div>
      {!searchSubscriptionId && description && (
        <ExtendTextContentContainer numberOfLines="2" buttonType="inlineButton">
          {description}
        </ExtendTextContentContainer>
      )}
    </header>
  );
};
